module.exports = __webpack_public_path__ + "static/1302577398-wide.c0bd9bdc.jpg";